import { render, staticRenderFns } from "./treeTable.vue?vue&type=template&id=4c8ac44e&scoped=true&"
import script from "./treeTable.vue?vue&type=script&lang=js&"
export * from "./treeTable.vue?vue&type=script&lang=js&"
import style0 from "./treeTable.vue?vue&type=style&index=0&id=4c8ac44e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8ac44e",
  null
  
)

export default component.exports